import { render, staticRenderFns } from "./certuficate.vue?vue&type=template&id=a9c59708"
import script from "./certuficate.vue?vue&type=script&lang=js"
export * from "./certuficate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports